/* eslint-disable */
import {
  post,
  get,
  put,
  _delete,
} from '@/lin/plugins/axios'

import _axios from '@/lin/plugins/axios'
  
class File {
  async upload(form) {
    const res = await post('plugin/file/', form)
    return res
  }

  getUploadUri() {
    return _axios.defaults.baseURL + 'plugin/file/'
  }

  getAssetUri(path) {
    return _axios.defaults.baseURL + `assets/${path}`
  }
}

export default new File()
